export default "__VITE_ASSET__56a28554__"